import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ArrowleftIcon from 'icons/Arrowleft.icon';
import ArrowrightIcon from 'icons/Arrowright.icon';

import './PreviewModalNavigationButtons.styles.scss';

type PreviewModalNavigationButtonsProps = {
  className?: string;
  canNavigate: boolean;
  onPrev: () => void;
  onNext: () => void;
};

const PreviewModalNavigationButtons: React.FC<
  PreviewModalNavigationButtonsProps
> = (props) => {
  const { className, canNavigate, onPrev, onNext } = props;

  const classes = classNames('preview-modal-navigation-buttons', className);

  if (!canNavigate) return null;

  return (
    <>
      <Button
        type="button"
        variant="icon"
        icon={ArrowleftIcon}
        className={classNames(classes, 'prev')}
        onClick={onPrev}
      />
      <Button
        type="button"
        variant="icon"
        icon={ArrowrightIcon}
        className={classNames(classes, 'next')}
        onClick={onNext}
      />
    </>
  );
};

export default PreviewModalNavigationButtons;
